var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.goToSinisterFile(_vm.sinister_id)}}},[_vm._v("\n    "+_vm._s(_vm.sinister_number)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/Reports/BudgetReport/SinisterDetail.vue